import { render, staticRenderFns } from "./searchStudent.vue?vue&type=template&id=330220a0&scoped=true&"
import script from "./searchStudent.vue?vue&type=script&lang=js&"
export * from "./searchStudent.vue?vue&type=script&lang=js&"
import style0 from "./searchStudent.vue?vue&type=style&index=0&id=330220a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330220a0",
  null
  
)

export default component.exports